// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hB6m_AXZbJkAOaSd4vU4 {
    position: relative;
    display: inline-block;
    user-select: none;
}

.WCjeP1j_4ghcrhb8mmLk { display: block; }


.deQT7041SnAb3P1XqA2h {
    position: fixed;
    
    top: 0;
    left: 0;

    z-index: 9999;
}


.KUxkhTf7CRcq9MDVz_us {
    position: absolute;

    pointer-events: none;
    /*
    left : \${ props => props.align == 'left' ? 0 : 'unset' };
    right : \${ props => props.align == 'right' ? 0 : 'unset' };*/

    top: 100%;

    z-index: 5000;

	text-align: left;

	margin: 0;
	padding: 0;

    background-color: var(--dropdown);
    color: var(--on-dropdown);

	border-radius: 3px;
	max-height: 240px;

	will-change: opacity, transform;

	width: 250px;

	overflow-y: auto;
	overflow-x: hidden;

    -webkit-overflow-scrolling: touch;

    box-shadow: 0 0 32px rgba(0, 0, 0, 0.7);
}

.Mi_e7gG0yVcIL7dPe_tv .KUxkhTf7CRcq9MDVz_us { pointer-events: all;}

.c3qpGSP4cG4dkVJ5Omnt .KUxkhTf7CRcq9MDVz_us { left: 0; }
.gKNOR1g2XnEWxj3QUhqQ .KUxkhTf7CRcq9MDVz_us { right: 0; }


.RPZ2lN_9Wdwa5zASphVA {
    list-style: none;

    min-height: 48px;

    overflow: hidden;

    cursor: pointer;

    border-bottom: 1px solid var(--dropdown-border-dark);
    
}

.RPZ2lN_9Wdwa5zASphVA:hover {
    background-color: var(--dropdown-light);
    color: var(--on-dropdown-light);
}

.RPZ2lN_9Wdwa5zASphVA:last-child { border-bottom: none; }



.Szv6UF8sLWE6z0XbI_ku {
    list-style: none;

    background-color: var(--dropdown-separator);
    color: var(--on-dropdown-separator);

    display: flex;
    padding: 0 12px;
    height: 24px;

    align-items: center;
    justify-content: space-between;

    overflow: hidden;

    cursor: default;

    border-bottom: 1px solid rgba(255, 255, 255, .1);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Dropdown.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,wBAAU,cAAc,EAAE;;;AAG1B;IACI,eAAe;;IAEf,MAAM;IACN,OAAO;;IAEP,aAAa;AACjB;;;AAGA;IACI,kBAAkB;;IAElB,oBAAoB;IACpB;;gEAE4D;;IAE5D,SAAS;;IAET,aAAa;;CAEhB,gBAAgB;;CAEhB,SAAS;CACT,UAAU;;IAEP,iCAAiC;IACjC,yBAAyB;;CAE5B,kBAAkB;CAClB,iBAAiB;;CAEjB,+BAA+B;;CAE/B,YAAY;;CAEZ,gBAAgB;CAChB,kBAAkB;;IAEf,iCAAiC;;IAEjC,uCAAuC;AAC3C;;AAEA,8CAAc,mBAAmB,CAAC;;AAElC,8CAAc,OAAO,EAAE;AACvB,8CAAe,QAAQ,EAAE;;;AAGzB;IACI,gBAAgB;;IAEhB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,eAAe;;IAEf,oDAAoD;;AAExD;;AAEA;IACI,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA,mCAAmB,mBAAmB,EAAE;;;;AAIxC;IACI,gBAAgB;;IAEhB,2CAA2C;IAC3C,mCAAmC;;IAEnC,aAAa;IACb,eAAe;IACf,YAAY;;IAEZ,mBAAmB;IACnB,8BAA8B;;IAE9B,gBAAgB;;IAEhB,eAAe;;IAEf,gDAAgD;AACpD","sourcesContent":[".container {\r\n    position: relative;\r\n    display: inline-block;\r\n    user-select: none;\r\n}\r\n\r\n.expand { display: block; }\r\n\r\n\r\n.menu-container {\r\n    position: fixed;\r\n    \r\n    top: 0;\r\n    left: 0;\r\n\r\n    z-index: 9999;\r\n}\r\n\r\n\r\n.menu {\r\n    position: absolute;\r\n\r\n    pointer-events: none;\r\n    /*\r\n    left : ${ props => props.align == 'left' ? 0 : 'unset' };\r\n    right : ${ props => props.align == 'right' ? 0 : 'unset' };*/\r\n\r\n    top: 100%;\r\n\r\n    z-index: 5000;\r\n\r\n\ttext-align: left;\r\n\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\r\n    background-color: var(--dropdown);\r\n    color: var(--on-dropdown);\r\n\r\n\tborder-radius: 3px;\r\n\tmax-height: 240px;\r\n\r\n\twill-change: opacity, transform;\r\n\r\n\twidth: 250px;\r\n\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\r\n    -webkit-overflow-scrolling: touch;\r\n\r\n    box-shadow: 0 0 32px rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.open .menu { pointer-events: all;}\r\n\r\n.left .menu { left: 0; }\r\n.right .menu { right: 0; }\r\n\r\n\r\n.item {\r\n    list-style: none;\r\n\r\n    min-height: 48px;\r\n\r\n    overflow: hidden;\r\n\r\n    cursor: pointer;\r\n\r\n    border-bottom: 1px solid var(--dropdown-border-dark);\r\n    \r\n}\r\n\r\n.item:hover {\r\n    background-color: var(--dropdown-light);\r\n    color: var(--on-dropdown-light);\r\n}\r\n\r\n.item:last-child { border-bottom: none; }\r\n\r\n\r\n\r\n.separator {\r\n    list-style: none;\r\n\r\n    background-color: var(--dropdown-separator);\r\n    color: var(--on-dropdown-separator);\r\n\r\n    display: flex;\r\n    padding: 0 12px;\r\n    height: 24px;\r\n\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    overflow: hidden;\r\n\r\n    cursor: default;\r\n\r\n    border-bottom: 1px solid rgba(255, 255, 255, .1);\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `hB6m_AXZbJkAOaSd4vU4`;
export var expand = `WCjeP1j_4ghcrhb8mmLk`;
var _1 = `deQT7041SnAb3P1XqA2h`;
export { _1 as "menu-container" };
export var menu = `KUxkhTf7CRcq9MDVz_us`;
export var open = `Mi_e7gG0yVcIL7dPe_tv`;
export var left = `c3qpGSP4cG4dkVJ5Omnt`;
export var right = `gKNOR1g2XnEWxj3QUhqQ`;
export var item = `RPZ2lN_9Wdwa5zASphVA`;
export var separator = `Szv6UF8sLWE6z0XbI_ku`;
export default ___CSS_LOADER_EXPORT___;
